import { render, staticRenderFns } from "./RelationshipRunDialog.vue?vue&type=template&id=00cff54f&scoped=true"
import script from "./RelationshipRunDialog.vue?vue&type=script&lang=js"
export * from "./RelationshipRunDialog.vue?vue&type=script&lang=js"
import style0 from "./RelationshipRunDialog.vue?vue&type=style&index=0&id=00cff54f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cff54f",
  null
  
)

export default component.exports